<template>
  <div>
    <div v-if="!item" class="example3">
      <a-spin />
    </div>
    <fo-layout v-else>
      <div class="areas-dtl">
        <p class="pages-return-btn">
          <span @click="$router.push('/practice/areas')"><a-icon type="left" /> Back</span>
        </p>
        <a-row :gutter="50">
          <a-col :sm="16">
            <div class="content-layout card-shadow">
              <div class="icon-bar">
                <div class="icon centerimage"
                  :style="'background-image: url(' + item.business_icon_default + ')'"> <!-- 背景图 --> </div>
                <img class="logo" src="../../../static/logo1.png" alt="">
                <h1 class="title">{{item.business_title_zh}}</h1>
              </div>
              <div style="white-space:pre-wrap;" class="info" v-html="item.business_content"></div>
            </div>
          </a-col>
          <a-col :sm="8">
            <div class="other-areas card-shadow">
              <div class="scroll" ref="scrollBar" style="overflow:hidden">
                <div class="btn top-btn" :class="{'btn-sele' : moveItem > 1}">
                  <a-icon type="up" @click="topHandle" />
                </div>
                <div  >
                  <ul ref="scrollContent" :style="'top:' + (-moveTop) + 'px'">
                    <fo-nodata v-if="!areasData.length"></fo-nodata>
                    <template v-for="(areasItem, ind) in areasData">
                      <li :key="ind" ref="zitem">
                        <cardAreas
                          :imgurl="areasItem.business_icon_default"
                          :title="areasItem.business_title_zh"
                          @click="$router.push('./' + areasItem.code)">
                        </cardAreas>
                      </li>
                    </template>
                  </ul>
                </div>
                <div class="btn bottom-btn" :class="{'btn-sele' : moveAction}">
                  <a-icon type="down" @click="bottomHandle" />
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
        <div class="cases-layout" v-if="casesData && casesData.length">
          <h1 class="title">Related Cases</h1>
          <a-row :gutter="50">
            <a-col :sm="8" v-for="(casesItem, ind) in casesData" :key="ind">
              <div class="pb-50">
                <cardCase
                  :imgurl="casesItem.case_poster_url"
                  :title="casesItem.case_title"
                  :industries="casesItem.case_industry_title_zh"
                  :areas="casesItem.case_business_title_zh"
                  @click="goToPage('../cases/' + casesItem.code)">
                </cardCase>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </fo-layout>
  </div>
</template>

<script>
import cardCase from './comps/cardCases.vue'
import cardAreas from './comps/cardAreasB.vue'
export default {
  components: {
    cardCase,
    cardAreas
  },
  data () {
    return {
      moveTop: 0, // 顶部距离
      moveItem: 1, // 移动到位置
      moveAction: true, // 可移动
      areasData: [], // 业务领域列表
      casesData: [], // 案列列表
      item: {},
      cond: {
        page_num: '1',
        page_size: '4'
      },
      casesCond: {
        page_num: '1',
        page_size: '6',
        case_business_id: ''
      }
    }
  },
  mounted () {
    this.readDtl()
    this.readList()
  },
  watch: {
    '$route.params.param' () {
      this.readDtl()
      this.readList()
    }
  },
  methods: {
    readList () {
      this.loading = true
      this.get({
        url: 'businessRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        this.areasData = res.data.items.filter(item => item.code !== this.$route.params.param)
        // 加载成功第一次计算上下按钮是否可以点击
        if (this.areasData && this.areasData.length) {
          setTimeout(() => {
            this.scrollHandle()
          }, 100)
        }
      })
    },
    readDtl () {
      this.get({
        url: 'businessFind',
        data: {
          code: this.$route.params.param
        }
      }, (res) => {
        this.item = res.data
        this.casesCond.case_business_id = this.item.id
        this.readCasesList()
      })
    },
    readCasesList () {
      this.get({
        url: 'casesRead',
        data: this.casesCond
      }, (res) => {
        this.casesData = res.data.items
      })
    },
    scrollHandle () {
      const barHeight = this.$refs.scrollBar.clientHeight
      const contHeight = this.$refs.scrollContent.clientHeight
      if (barHeight * this.moveItem >= contHeight) {
        // 已经到低了
        this.moveTop = (contHeight - barHeight)
        this.moveAction = false
      } else {
        // 可已继续移动
        this.moveTop = (barHeight * (this.moveItem - 1))
        this.moveAction = true
      }
    },
    topHandle () {
      if (this.moveItem > 1) {
        this.moveItem -= 1
        this.scrollHandle()
      }
    },
    bottomHandle () {
      if (this.moveAction) {
        this.moveItem += 1
        this.scrollHandle()
      }
    },
    // 跳转详情
    goToPage (router) {
      window.scroll(0, 0)
      this.$router.push(router)
    }
  }
}
</script>

<style lang="less">
  @import url('../../utils/color.less');
/* 小于等于 750 */
@media screen and (max-width: 751px) and (min-width: 300px) {
  @pageHeight: 720px;
  .areas-dtl {
    .content-layout {
      min-height: @pageHeight;
      padding: 30px;
      background: #FFF;
      position: relative;
      overflow: hidden;
      margin-bottom: 30px;
      .icon-bar {
        .icon {
          width: 140px;
          height: 140px;
        }
        .logo {
          width: 300px;
          height: 300px;
          position: absolute;
          right: -60px;
          top: -40px;
        }
        h1 {
          font-family: Georgia, 宋体;
          font-weight: bold;
          margin: 10px 0 20px;
        }
      }
    }
    .other-areas {
      padding: 30px 0;
      background: #FFF;
      height: @pageHeight;
      .scroll {
        padding: 50px 0;
        height: 100%;
        position: relative;
        .btn {
          width: 100%;
          text-align: center;
          font-size: 26px;
          position: absolute;
          left: 0;
        }
        .top-btn {
          top: 0;
          color: @silverlight;
        }
        .bottom-btn {
          bottom: 0;
          color: @primary;
        }
        .btn-sele {
          color: @primary;
        }
        .scroll-bar {
          height: 100%;
          overflow: hidden;
          position: relative;
        }
        ul {
          height: 100%;
          overflow: auto;
          &::-webkit-scrollbar {
            width: 4px;
            background-color: rgba(0,0,0,0.1);
            border-radius: 3px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: rgba(0,0,0,0.6);
            border-radius: 3px;
          }
        }
        li {
          &:before {
            content: '';
            display: block;
            width: 80%;
            margin: auto;
            border-top: 1px solid @graydark;
          }
        }
        li:last-child {
          &:after {
            content: '';
            display: block;
            width: 80%;
            margin: auto;
            border-top: 1px solid @graydark;
          }
        }
      }
    }
    .cases-layout {
      padding-top: 50px;
      .title {
        height: 60px;
        font-weight: bold;
        font-family: Georgia, 宋体;
        margin-bottom: 30px;
        border-bottom: 1px solid @graydark;
      }
    }
  }
}
/* 大于 750 */
@media screen and (min-width: 751px) {
  @pageHeight: 720px;
  .areas-dtl {
    .content-layout {
      min-height: @pageHeight;
      padding: 30px;
      background: #FFF;
      position: relative;
      overflow: hidden;
      .icon-bar {
        .icon {
          width: 140px;
          height: 140px;
        }
        .logo {
          width: 300px;
          height: 300px;
          position: absolute;
          right: -60px;
          top: -40px;
        }
        h1 {
          font-family: Georgia, 宋体;
          font-weight: bold;
          margin: 10px 0 20px;
        }
      }
    }
    .other-areas {
      padding: 30px 0;
      background: #FFF;
      height: @pageHeight;
      .scroll {
        padding: 50px 0;
        height: 96%;
        .btn {
          width: 100%;
          text-align: center;
          font-size: 26px;
          color: @silverlight;
          position: absolute;
          left: 0;
        }
        .top-btn {
          top: 22px;
        }
        .bottom-btn {
          bottom: 22px;
        }
        .btn-sele {
          color: @primary;
        }
        .scroll-bar {
          height: 100%;
          overflow: hidden;
          position: relative;
        }
        ul {
          height: 100%;
          overflow: auto;
          &::-webkit-scrollbar {
            width: 4px;
            background-color: rgba(0,0,0,0.1);
            border-radius: 3px;
          }
          &::-webkit-scrollbar-thumb {
            background-color: rgba(0,0,0,0.6);
            border-radius: 3px;
          }
        }
        li {
          &:before {
            content: '';
            display: block;
            width: 80%;
            margin: auto;
            border-top: 1px solid @graydark;
          }
        }
        li:last-child {
          &:after {
            content: '';
            display: block;
            width: 80%;
            margin: auto;
            border-top: 1px solid @graydark;
          }
        }
      }
    }
    .cases-layout {
      padding-top: 50px;
      .title {
        height: 60px;
        font-weight: bold;
        font-family: Georgia, 宋体;
        margin-bottom: 30px;
        border-bottom: 1px solid @graydark;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Models/areasDtl.vue